module.exports = __webpack_public_path__ + "img/CheckCircle-blue.61ab4d4f.svg";